(function () {
  var root = document.querySelector('[data-bff-install-float]');
  if (!root) return;

  var tab = root.querySelector('[data-bff-install-tab]');
  var panel = root.querySelector('[data-bff-install-panel]');
  var closeBtn = root.querySelector('[data-bff-install-close]');
  var storageKey = 'bff_install_float_dismissed';
  var autoOpened = false;

  function isDismissed() {
    try { return sessionStorage.getItem(storageKey) === '1'; } catch (e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
  }

  function openPanel() {
    if (!panel || !tab) return;
    panel.hidden = false;
    root.classList.add('bff-install-float--open');
    tab.setAttribute('aria-expanded', 'true');
  }

  function closePanel(dismiss) {
    if (!panel || !tab) return;
    panel.hidden = true;
    root.classList.remove('bff-install-float--open');
    tab.setAttribute('aria-expanded', 'false');
    if (dismiss) setDismissed();
  }

  function togglePanel() {
    if (root.classList.contains('bff-install-float--open')) {
      closePanel(false);
    } else {
      openPanel();
    }
  }

  if (tab) tab.addEventListener('click', togglePanel);
  if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(true); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('bff-install-float--open')) {
      closePanel(false);
    }
  });

  if (isDismissed()) return;

  /* Auto slide-in after user scrolls a bit */
  function onScroll() {
    if (autoOpened || isDismissed()) return;
    if (window.scrollY > 320) {
      autoOpened = true;
      openPanel();
      window.removeEventListener('scroll', onScroll, { passive: true });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
